/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedKrajListListResponse } from '../types/PaginatedKrajListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type KrajeListRequest = {} | null | undefined;
export type KrajeListResponse = PaginatedKrajListListResponse;

export type KrajeListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/kraje/
 *
 * ```yaml
 * operationId: kraje_list
 * tags:
 *   - kraje
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedKrajListList'
 *     description: ''
 * ```
 */
export const krajeListOperation = (rest?: KrajeListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/kraje/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/kraje/' };
  };

/**
 * GET /dmx-server/kraje/
 *
 * ```yaml
 * operationId: kraje_list
 * tags:
 *   - kraje
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedKrajListList'
 *     description: ''
 * ```
 */
export const krajeList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: KrajeListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedKrajListListResponse>> => {
  const operation = krajeListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/kraje/
 */
export const useKrajeListResource = (
  query: KrajeListQuery | null,
  useCached?: boolean,
): UseResource<KrajeListResponse> => {
  return useResource<KrajeListResponse>({
    path: query === null ? null : krajeListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
